import React from "react";

function AnnexesManifesto() {
  return (
    <section>
      <p>
        Quand l’information et la culture sont trop souvent traitées comme des
        marchandises, quel rôle les citoyen·ne·s peuvent-ils encore jouer pour
        faire vivre le pluralisme et le débat ? Cette question appelle une
        réponse qui ne saurait attendre.
      </p>
      <p>
        Un peu partout, des millions de gens s’investissent et agissent sur leur
        quotidien sans attendre le bon vouloir des pouvoirs publics et à
        contre-courant des puissances industrielles ou financières. Économie
        sociale et solidaire, écologie, humanitaire, progrès scientifique ou
        avancées technologiques — des millions de gens mettent désormais leurs
        moyens et leur volonté au service de projets alternatifs. Par leur
        succès et leur envergure, ces projets prouvent une chose simple : il est
        possible de faire autrement et dès maintenant.
      </p>
      <p>
        Aussi, à l’image de ces citoyen·ne·s qui se sont par exemple organisés
        pour produire et commercialiser des aliments biologiques dans le respect
        de l’environnement, de la santé publique et de la dignité des
        producteurs, nous, signataires de ce manifeste, considérons qu’il est
        possible d’intervenir dans le domaine de l’information et de la culture.
      </p>
      <p>
        C’est pourquoi, nous appelons à soutenir la création d’un nouveau média
        fondamentalement alternatif par sa gouvernance, son modèle économique et
        son fonctionnement. Généraliste, diffusé gratuitement sur Internet,
        audiovisuel et écrit, ses objectifs devront être clairs :
      </p>
      <ol>
        <li>
          <strong>Ce média, coopératif, sera indépendant</strong> : sa
          gouvernance impliquera ses sociétaires, ses salarié·e·s et ses «
          bénéficiaires ».
        </li>
        <li>
          <strong>Ce média sera collaboratif</strong> : s’appuyant sur un réseau
          de correspondant·e·s, d’associations, d’ONG, il fera appel aux
          collaborations citoyennes.
        </li>
        <li>
          <strong>Ce média sera pluraliste</strong> : s’affranchissant de la
          dictature de l’urgence, il laissera sa place à la confrontation des
          idées et aux débats de fond.
        </li>
        <li>
          <strong>Ce média sera culturel et francophone</strong> : sans se
          limiter au seul hexagone, il contribuera à la valorisation et à la
          création culturelle de la francophonie.
        </li>
        <li>
          <strong>Ce média sera humaniste et antiraciste</strong> : il
          s’engagera dans la lutte contre les discriminations et travaillera au
          renforcement des solidarités humaines.
        </li>
        <li>
          <strong>Ce média sera féministe et défendra les droits LGBTI</strong>{" "}
          : il soutiendra l’émancipation des femmes et l’égalité entre les
          genres.
        </li>
        <li>
          <strong>Ce média sera écologiste et progressiste</strong> : il
          soutiendra les initiatives qui favorisent l’harmonie entre les humains
          et la nature.{" "}
        </li>
      </ol>
      <p>
        Voilà l’ambition de cet appel, lancé à tous ceux et à toutes celles qui
        se reconnaîtront dans un tel projet : s’éloigner du modèle économique et
        idéologique dominant pour bâtir un espace commun et visible, influent et
        fraternel, un espace qui agrège et rassemble des initiatives citoyennes.
      </p>
    </section>
  );
}

export default AnnexesManifesto;
